@if (isShown()) {
  @if (isDone()) {
    <svg viewBox="0 0 231 216" class="absolute inset-0 size-full overflow-visible" aria-hidden="true">
      <defs>
        <linearGradient [attr.id]="gradientId" gradientUnits="userSpaceOnUse" x1="20" y1="30" x2="210" y2="190">
          <stop offset="0" style="stop-color: var(--colors-background-accent-alt-3)" />
          <stop offset="0.5" style="stop-color: var(--colors-background-accent-alt-4)" />
          <stop offset="1" style="stop-color: var(--colors-background-accent-alt-2)" />
        </linearGradient>
      </defs>
      <g [attr.transform]="checkmark.transform()">
        <path fill="currentColor" [attr.d]="checkmark.topPath()" />
        <path fill="currentColor" [attr.d]="checkmark.bottomPath()" />
        <g [attr.opacity]="checkmark.overlayOpacity()">
          <path [attr.fill]="checkmarkFill()" [attr.d]="checkmark.topPath()" />
          <path [attr.fill]="checkmarkFill()" [attr.d]="checkmark.bottomPath()" />
        </g>
      </g>
    </svg>
  } @else {
    <span class="absolute inset-0 animate-branded-loader-turn motion-reduce:animate-none">
      <span
        class="absolute inset-0 origin-branded-loader-top animate-branded-loader-apart-top motion-reduce:animate-none"
      >
        <svg viewBox="0 0 231 216" class="absolute inset-0 size-full overflow-visible" aria-hidden="true">
          <path fill="currentColor" [attr.d]="logoTopBar" />
        </svg>
      </span>
      <span
        class="absolute inset-0 origin-branded-loader-bottom animate-branded-loader-apart-bottom motion-reduce:animate-none"
      >
        <svg viewBox="0 0 231 216" class="absolute inset-0 size-full overflow-visible" aria-hidden="true">
          <path fill="currentColor" [attr.d]="logoBottomBar" />
        </svg>
      </span>
    </span>
  }

  <span class="sr-only">
    @if (isDone()) {
      {{ doneLabel() ?? ('Done' | translate) }}
    } @else {
      {{ loadingLabel() ?? ('Loading' | translate) }}
    }
  </span>
}
